import React, { useState, useEffect } from 'react';

export default function WelcomeModal() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Garante que o modal vai aparecer apenas uma única vez para o usuário
    const hasSeenWelcome = localStorage.getItem('doisplay_welcomed_v2');
    if (!hasSeenWelcome) {
      setShowModal(true);
    }
  }, []);

  const handleClose = () => {
    setShowModal(false);
    localStorage.setItem('doisplay_welcomed_v2', 'true'); // Grava a chave para nunca mais exibir
  };

  if (!showModal) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.88)', zIndex: 9999,
      display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px',
      backdropFilter: 'blur(5px)'
    }}>
      <div style={{
        backgroundColor: '#141414', border: '1px solid #333', borderRadius: '14px',
        maxWidth: '540px', width: '100%', padding: '40px 35px', textAlign: 'left',
        boxShadow: '0 25px 50px rgba(0,0,0,0.9)', position: 'relative',
        maxHeight: '90vh', overflowY: 'auto'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <span style={{ color: '#E50914', fontWeight: 'bold', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '2px' }}>
            Plataforma Beta • Versão Oficial 🇧🇷
          </span>
          <h2 style={{ fontSize: '24px', fontWeight: '900', color: '#fff', margin: '10px 0 5px 0' }}>
            Bem-vindo(a) ao Doisplay!
          </h2>
        </div>

        <div style={{ fontSize: '13px', color: '#bbb', lineHeight: '1.6', display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '30px' }}>
          <p style={{ margin: 0 }}>
            🚀 O <strong>Doisplay</strong> funciona como um indexador e vitrine inteligente de conteúdos audiovisuais, incorporando vídeos públicos (como do YouTube) para facilitar a sua navegação e descoberta de entretenimento.
          </p>
          <p style={{ margin: 0 }}>
            💡 <strong>Apoio aos Criadores:</strong> Nosso objetivo é impulsionar e dar visibilidade aos criadores de conteúdo e canais parceiros, direcionando audiência diretamente para eles.
          </p>
          <p style={{ margin: 0, backgroundColor: 'rgba(255,255,255,0.03)', padding: '10px 12px', borderRadius: '6px', borderLeft: '3px solid #E50914' }}>
            ⚠️ <strong>Aviso Importante sobre Anúncios:</strong> Por utilizarmos players incorporados, eventuais anúncios exibidos durante a reprodução são de total responsabilidade dos respectivos criadores e plataformas de hospedagem (como o YouTube), não tendo o Doisplay controle direto sobre eles.
          </p>
        </div>

        <button
          onClick={handleClose}
          style={{
            width: '100%', backgroundColor: '#E50914', color: '#fff', border: 'none',
            padding: '14px', borderRadius: '6px', fontWeight: 'bold', fontSize: '15px',
            cursor: 'pointer', transition: 'background 0.2s'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#b20710'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#E50914'}
        >
          Entendido, Começar a Explorar 🚀
        </button>
      </div>
    </div>
  );
}